import makeStyles from '@material-ui/core/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
  paper: {
    background: 'white',
    border: '1px solid #D9D9D9',
    width: '80vw',
    maxWidth: 900,
    borderRadius: 4,
    padding: theme.spacing(4),
  },
  title: {
    fontWeight: 700,
    fontSize: 24,
    color: '#192542',
  },
}));
